import { useState, useEffect } from 'react';

const LIGHT_BACKGROUNDS = ['#F2F3F4', '#FFFFFF', 'rgb(242, 243, 244)', 'rgb(255, 255, 255)', 'rgb(242, 243, 244)'];

export const useBackgroundColor = (elementRef: React.RefObject<HTMLElement>) => {
  const [isLightBackground, setIsLightBackground] = useState(false);

  useEffect(() => {
    const checkBackground = () => {
      if (!elementRef.current) return;

      const rect = elementRef.current.getBoundingClientRect();
      const y = rect.top + rect.height / 2;

      // Check if we're over any light background sections
      const lightSections = [
        ...Array.from(document.querySelectorAll('.bg-\\[\\#F2F3F4\\]')), // Light gray sections
        ...Array.from(document.querySelectorAll('.bg-white')), // White sections
        ...Array.from(document.querySelectorAll('[style*="background-color: rgb(242, 243, 244)"]')), // F2F3F4 with rgb
        ...Array.from(document.querySelectorAll('[style*="background-color"]')).filter(el => {
          const bgColor = window.getComputedStyle(el).backgroundColor;
          return LIGHT_BACKGROUNDS.includes(bgColor);
        })
      ];

      const isOverLightSection = lightSections.some(section => {
        const sectionRect = section.getBoundingClientRect();
        return y >= sectionRect.top && y <= sectionRect.bottom;
      });

      setIsLightBackground(isOverLightSection);
    };

    const observer = new MutationObserver(checkBackground);
    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true,
      characterData: true 
    });

    window.addEventListener('scroll', checkBackground);
    window.addEventListener('resize', checkBackground);

    checkBackground();

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', checkBackground);
      window.removeEventListener('resize', checkBackground);
    };
  }, [elementRef]);

  return isLightBackground;
};